const VENDORS = [
  {
    label: "Payu",
    value: "payu",
  },
  {
    label: "Pinelab",
    value: "pinelab",
  },
  {
    label: "Razorpay",
    value: "razorpay",
  },
];

export { VENDORS };
